module.exports = __webpack_public_path__ + "static/media/PDF14.4f5d4b18.pdf";